<template>
    <div>
        <pc-label
            v-if="label"
            v-bind="labelBinder"
            v-on:help-clicked="$emit('help-clicked', $event)" />
        <input
            v-bind="formattedBinder"
            ref="input"
            v-model="internalValue"
            v-format="format"
            v-bind:inputmode="inputmode"
            class="form-control d-block d-print-none"
            v-on="listeners" />
        <div class="d-none d-print-block form-control height-corrections">
            {{ internalValue }}
        </div>
        <div
            v-if="showValidationErrors"
            class="invalid-feedback fw-bold">
            {{ validationError }}
        </div>
    </div>
</template>

<script>
    import base from "./_inputBase.vue";
    import { isIE } from "Util/util.js";

    function formatString(str, format) {
        str = str.replace(/#/g, "");
        if (str === "") {
            return "";
        }

        let formattedStr = "";
        let mIndex = 0;
        let matching = true;

        while (matching && mIndex < str.length) {
            const char = str[mIndex];
            const proxyChar = /^\d$/.test(char) ? "#" : char;

            if (mIndex < format.length && proxyChar === format[mIndex]) {
                formattedStr += char;
                mIndex++;
            } else {
                matching = false;
            }
        }
        str = str.slice(mIndex).replace(/[^\d]/g, "");
        let fIndex = mIndex;
        let sIndex = 0;

        while (fIndex < format.length && sIndex < str.length) {
            if (format[fIndex] === "#") {
                formattedStr += str[sIndex];
                sIndex++;
            } else {
                formattedStr += format[fIndex];
            }
            fIndex++;
        }

        return formattedStr;
    }

    export default {
        directives: {
            format(el, binding) {
                const formatStr = binding.value;

                const handleInputEvent = function (evt) {
                    if (!evt.isTrusted) {
                        return;
                    }
                    // separate the formatting into two parts. The one before the cursor and then the whole thing
                    // we do this to be able to tell the position of the cursor at the end.
                    let cursorPos = el.selectionStart;
                    let firstPart = el.value.slice(0, cursorPos);
                    firstPart = formatString(firstPart, formatStr);
                    cursorPos = firstPart.length;

                    el.value = formatString(el.value, formatStr);

                    if (el === document.activeElement) {
                        el.setSelectionRange(cursorPos, cursorPos);
                    }

                    const ev = new CustomEvent("input", { bubbles: true, cancelable: true });
                    el.dispatchEvent(ev);
                };
                if (!isIE()) {
                    el.addEventListener("input", handleInputEvent, { once: true });
                } else {
                    el.oninput = function (evt) {
                        if (!evt.isTrusted) {
                            return;
                        }
                        // separate the formatting into two parts. The one before the cursor and then the whole thing
                        // we do this to be able to tell the position of the cursor at the end.
                        let cursorPos = el.selectionStart;
                        let firstPart = el.value.slice(0, cursorPos);
                        firstPart = formatString(firstPart, formatStr);
                        cursorPos = firstPart.length;

                        el.value = formatString(el.value, formatStr);

                        if (el === document.activeElement) {
                            el.setSelectionRange(cursorPos, cursorPos);
                        }

                        const ev = new CustomEvent("input", { bubbles: true, cancelable: true });
                        el.dispatchEvent(ev);
                    };
                }
            }
        },
        extends: base,
        props: {
            format: { type: String, required: true },
            useFormatAsPlaceholder: { type: Boolean, required: false, default: false },
            inputmode: { type: String, required: false, default: null }
        },
        emits: ["help-clicked"],
        data: function () {
            return {
                internalType: "text"
            };
        },
        computed: {
            formattedBinder() {
                const binder = this.binder;
                if (this.useFormatAsPlaceholder) {
                    binder.placeholder = this.format;
                }
                return binder;
            }
        }
    };
</script>

<style lang="scss" scoped>
    .height-corrections {
        height: auto !important;
        min-height: var(--pc-input-height) !important;
    }
</style>
